export default __webpack_public_path__ + "static/media/palet.bddee635.png";